import { createEntityAdapter } from '@reduxjs/toolkit'
import { Depot } from './models/Depot'

export const depotsAdapter = createEntityAdapter({
  selectId: (depot: Depot) => depot.id,
})